import React, { useEffect, useState } from 'react'
import logo from '../assets/webbull-logo-final.png'
import '../layouts/ansysoft.css'
import home from '../assets/icon/home.svg'
import OurCommunity from '../assets/icon/community.svg'
import AboutUs from '../assets/icon/about-us.svg'
import FAQ from '../assets/icon/faq.svg'
import gifImg from '../assets/self-trading/trading-graph-8.gif'
import { fetchNFTs } from '../api/api'
import NFTFooter from '../components/NFTFooter'
import Footer from '../components/footer'

const Nft = () => {

    const [todayPurchase, setTodayPurchase] = useState(0);
    const [purchasedCards, setPurchasedCards] = useState([]);
    const [NFT, setNFT] = useState([]);

    // const cards = [
    //     { id: 1, image: gifImg, number: "#1014", price: "48.00 USDT" },
    //     { id: 2, image: gifImg, number: "#1015", price: "50.00 USDT" },
    //     { id: 3, image: gifImg, number: "#1016", price: "52.00 USDT" },
    //     { id: 4, image: gifImg, number: "#1017", price: "49.00 USDT" },
    //     { id: 5, image: gifImg, number: "#1018", price: "47.00 USDT" }
    // ];

    useEffect(() => {
        //    fetchNFTs()
        // //    .then(res => console.log(res.lastCallData.data));
        //    .then(res => setNFT(res.lastCallData.data));

        const func = async () => {
            const response = await fetchNFTs();
            setNFT(response.lastCallData.data);
        }
        func();
    }, []);

    const handlePurchase = (cardId) => {

        if (todayPurchase < 2) {
            setTodayPurchase((prev) => prev + 1);
            setPurchasedCards((prev) => [...prev, cardId]);
        } else {
            alert("Purchase limit reached!");
        }
    }

    // const getNFTList = () => {
    //     fetchNFTs();
    // }

    return (
        <>
            <div className='nft-container'>
                <div className='nft-header'>
                    {/* <h1>WebBull</h1> */}
                    <img src={logo} alt="WebBull logo" title="Webbull" className='logo' />
                </div>
                <div className='NftInvt-container mt-2' >
                    <div className='invt-row'>
                        <div className='invt-info'>
                            <h2>Purchase Frequency</h2>
                            <h3>{todayPurchase}/2</h3>
                        </div>
                    </div>
                    <div className='collections'>
                        {/* <div className='collection-card' id='1'>
            <img src={gifImg} alt="Card Image"/>
            <h2>#1014</h2>
            <h3>Price : 48.00 USDT</h3>
            <button onClick={handelPurchase} className='card-btn'>Buy Now</button>
        </div> */}
                        {NFT.map((NFT) => (
                            !purchasedCards.includes(NFT.nft_id) && (
                                <div className='collection-card' key={NFT.nft_id}>
                                    {/* <img src={NFT.image} alt="Card Image" /> */}
                                    <img src={`https://ansysoft.com/webb-api/images/self-trading/${NFT.image}`} alt="Card Image" />
                                    {/* <img src={`https://ansysoft.com/projects/ecom/webb/api/images/self-trading/${NFT.image}`} alt="Card Image" /> */}
                                    {/* <img src={`http://192.168.1.3/ecom/webb/api/images/self-trading/${NFT.image}`} alt="Card Image" /> */}
                                    <h2>{NFT.nft_name}</h2>
                                    <h3>Price: {NFT.price} USDT</h3>
                                    <button onClick={() => handlePurchase(NFT.nft_id)} className='card-btn'>
                                        Buy Now
                                    </button>
                                </div>
                            )
                        ))}

                    </div>

                </div>
            <div className='nftFooter'>
                <NFTFooter />
            </div>
            </div>
        </>
    )
}

export default Nft;